import { css } from '@emotion/react';

/** App shell: reset, fonts, and shared utilities only */
export const LayoutComponent = css`
  @import url('https://fonts.googleapis.com/css2?family=Raleway:wght@400;700&display=swap');

  :root {
    font-size: 20px;
  }

  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    min-height: 100vh;
    margin: 0;
    font-size: 20px;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  p,
  label,
  input,
  textarea,
  button,
  a {
    font-family: 'Raleway', sans-serif !important;
  }

  form {
    background-color: white;
    border-radius: 5px;
  }

  .hidden,
  .hide {
    display: none !important;
  }

  .ui.button {
    margin: 5px;
  }

  @media only screen and (max-width: 600px) {
    .input {
      padding: 5px !important;
    }
  }
`;

export const appShellStyles = css`
  width: 100%;
  min-height: 100vh;
  background-color: #dedede;
`;
